export const outboundLinks = Object.freeze({
  bigHorn: {
    root: "https://bhooc.com",
    evoos: "/product-category/traditional",
    balsamics: "/product-category/traditional",
  }
});
